import { Router, Redirect } from "@reach/router";
import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Loader } from "@xingternal/crate-communication-loader";
import { RootProvider } from "@xingternal/crate-communication-root-provider";
import { useLoginState } from "@xingternal/crate-hooks-use-login-state";
import { ScrollManager } from "@xingternal/crate-layout-scroll-memo-module";
import { NoSSR } from "@xingternal/crate-utils-no-ssr";
import GlobalStyles from "@xingternal/global-styles";
import { XingHubProvider } from "@xingternal/xing-hub";
import { parseCookies } from "@xingternal/xing-hub/lib/parseCookies";
import { useRoutingData } from "./data-layer";
import { NotFound } from "./error-components";
import {
  LoggedInFrameProvider,
  LoggedOutFrameProvider
} from "./frame-provider";
import { initTracking } from "./init-tracking";
import { internalPaths } from "./internal-paths";
import { Route } from "./route";
import { useRegisterExperiments } from "./use-register-experiments";
import { WaitForUser } from "./wait-for-user";
const Routing = ({ setActiveItem }) => {
  const routingData = useRoutingData();
  return /* @__PURE__ */ React.createElement(Router, null, /* @__PURE__ */ React.createElement(Redirect, {
    noThrow: true,
    from: "/discover/",
    to: "/discover/updates"
  }), routingData.map((route) => /* @__PURE__ */ React.createElement(Route, {
    path: route.route,
    data: route,
    key: "static",
    setActiveItem
  })), /* @__PURE__ */ React.createElement(NotFound, {
    default: true
  }));
};
const ttt = initTracking();
const cookies = parseCookies(globalThis.document ? globalThis.document.cookie : "");
const Root = ({ host }) => {
  useRegisterExperiments();
  const loginState = useLoginState();
  const [activeItem, setActiveItem] = React.useState();
  return /* @__PURE__ */ React.createElement(XingHubProvider, {
    value: { cookies }
  }, /* @__PURE__ */ React.createElement(GlobalStyles, null, loginState.loginState === void 0 ? /* @__PURE__ */ React.createElement(Loader, null) : loginState.isLoggedIn ? /* @__PURE__ */ React.createElement(LoggedInFrameProvider, {
    activeItem,
    internalPaths
  }, /* @__PURE__ */ React.createElement(host.XingletLoader, {
    name: "@xingternal/crate-communication-core-tracking"
  }), /* @__PURE__ */ React.createElement(WaitForUser, null, /* @__PURE__ */ React.createElement(Routing, {
    setActiveItem
  })), /* @__PURE__ */ React.createElement(host.XingletLoader, {
    name: "@xingternal/crate-marketing-braze",
    ttt
  }), /* @__PURE__ */ React.createElement(NoSSR, null, /* @__PURE__ */ React.createElement(ScrollManager, null))) : /* @__PURE__ */ React.createElement(LoggedOutFrameProvider, {
    internalPaths
  }, /* @__PURE__ */ React.createElement(Routing, {
    setActiveItem
  }), /* @__PURE__ */ React.createElement(NoSSR, null, /* @__PURE__ */ React.createElement(ScrollManager, null)))));
};
class RootXinglet {
  async registerMocks(msw) {
    (await import("@xingternal/crate-communication-mocks")).setupMocking(msw);
  }
  getComponent(host) {
    return ({ basePath }) => {
      return /* @__PURE__ */ React.createElement(host.XingletLoader, {
        name: "@xingternal/crate-core-hops-environment",
        fallback: /* @__PURE__ */ React.createElement(Loader, null),
        basePath
      }, /* @__PURE__ */ React.createElement(Helmet, null, /* @__PURE__ */ React.createElement("title", null, "XING"), /* @__PURE__ */ React.createElement("meta", {
        name: "viewport",
        content: "width=device-width, minimum-scale=1, maximum-scale=1"
      })), /* @__PURE__ */ React.createElement(RootProvider, null, /* @__PURE__ */ React.createElement(Root, {
        host
      })));
    };
  }
}
export {
  RootXinglet as default
};
